export default {
  add: '添加',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  view: '查看',
  mod: '修改',
  delete: '删除',
  choose: '选择'
};


// WEBPACK FOOTER //
// ./src/lib/locales/zh-CN.js